// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"b0ce9779","71":"714a9089","249":"87db273e","791":"c1e4abb5","886":"52f59181"}[chunkId] + ".js";
};